<template>
    <div class="tab-pane active" id="marketer_subsets_list">
        <common-filter :action="filterAction"/>
        <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
    </div>
</template>

<script>
import columns from "../datatable/marketerColumnsWithManageAccess"
import { ApiUrl } from '@/common/api.service'
import { AuthorizationHeader } from '@/common/jwt.service'
import CommonFilter from "./common-filter";

export default {
    name: 'MarketerSubsets',
    components: {
         'common-filter': CommonFilter,
    },
    data() {
        return {
            headerAction: {
                left: '10px',
                top: '10px',
                position: 'absolute'
            },
            hashid: this.$route.params.user_id,
            query: {}
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "subsets_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: this.getApiUrl(),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function(res) {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        }
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                pagination: false,
                sortable: true,
                columns: columns,
            }
        },
    },
    methods: {
        filterAction(e, query) {
            this.query = query
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        },
        getApiUrl() {
            return this.$route.params.tab == "starshop" ? ApiUrl.starshopPath('marketing/' + this.hashid + '/subsets') : ApiUrl.path('marketing/' + this.hashid + '/subsets');
        }
    },
}
</script>

<style>

</style>